import { Flex } from '@chakra-ui/react';
import { FC } from 'react';

import PaginationContentWrap from 'presentation/components/shared/pagination/PaginationContentWrap';
import { useNavigate } from 'react-router-dom';
import AppRoute from 'router/AppRoute';
import OrdersGridItem from './OrdersGridItem';

interface Props extends PaginationListProps<OrderListItem> {}

const OrdersGrid: FC<Props> = ({
  items,
  isFetching,
  setPage,
  currentPage,
  pageCount,
}) => {
  const navigate = useNavigate();

  return (
    <PaginationContentWrap
      itemsCount={items.length}
      isFetching={isFetching}
      setPage={setPage}
      currentPage={currentPage}
      pageCount={pageCount}
    >
      <Flex flexWrap="wrap" justifyContent="space-between">
        {items.map((order) => (
          <OrdersGridItem
            key={order.id}
            orderData={order}
            mb="20px"
            onDetailClick={() => {
              navigate(AppRoute.recommendationDetail(order.id));
            }}
          />
        ))}
      </Flex>
    </PaginationContentWrap>
  );
};

export default OrdersGrid;
